import * as _ from 'lodash';
import toastr from 'toastr';
import ApiService from '../../../../service/apiService';
import logUtils from '../../../../HelperMethods/LogUtils';
import {
  loadPicklist,
  setFormLoader,
  setLoader,
  upsertPicklist,
  deletePicklist as deletePicklistFromRedux,
  setAssetAttributes,
} from './reducer';
import { PROTECTED_PICKLIST_NAMES } from '../../constants';

export function loadPicklists() {
  return async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const response = await ApiService.bulkDownloadPicklists();
      const successResponse = _.get(response, 'data.rpcService.success');
      if (!successResponse) {
        throw response;
      }
      const picklists =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (picklists) {
        dispatch(loadPicklist(picklists));
      } else {
        throw new Error('Picklists not found in api');
      }
    } catch (e) {
      dispatch(loadPicklist([]));
      logUtils.logError(e, 'Loading Picklists Failed');
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function updatePicklist(picklist) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      const response = await ApiService.upsertPicklist(picklist);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      const updatedPicklist =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (!updatedPicklist) throw new Error('Didnt receive updated Picklist from api');
      toastr.success('Picklist updated');
      dispatch(upsertPicklist(updatedPicklist));
    } catch (e) {
      logUtils.logError(e, 'Updating Picklist failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function createPicklist(picklist) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      delete picklist.id;
      const response = await ApiService.upsertPicklist(picklist);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      const createdPicklist =
        _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (!createdPicklist) throw new Error('Picklist not created');
      toastr.success('Picklist Created');
      dispatch(upsertPicklist(createdPicklist));
    } catch (e) {
      logUtils.logError(e, 'Picklist creation failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function onSubmitButtonClicked(picklist) {
  return async (dispatch) => {
    const clonedPicklist = _.clone(picklist);
    if (picklist.id) {
      await updatePicklist(clonedPicklist)(dispatch);
    } else {
      await createPicklist(clonedPicklist)(dispatch);
    }
  };
}

export function deletePicklist(picklist) {
  return async (dispatch) => {
    const ifProtectedPicklistIsBeingDeleted = PROTECTED_PICKLIST_NAMES.includes(picklist.name);
    if (ifProtectedPicklistIsBeingDeleted) {
      toastr.error(`${picklist.name} cannot be deleted`);
      return;
    }
    dispatch(setLoader(true));
    const clonedPicklist = _.clone(picklist);
    clonedPicklist.isDeleted = true;
    try {
      const response = await ApiService.upsertPicklist(clonedPicklist);
      const success = _.get(response, 'data.rpcService.success');
      if (!success) {
        throw response;
      }
      dispatch(deletePicklistFromRedux(picklist));
      toastr.success('Picklist Deleted');
    } catch (e) {
      logUtils.logError(e, 'Picklist deleting failed');
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function refreshMetadataPicklist(picklistId) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    const picklist = await ApiService.refreshMetadataPicklist(picklistId);
    dispatch(upsertPicklist(picklist));
    dispatch(setFormLoader(false));
  };
}

export function downloadAllAssetAttributes() {
  return async (dispatch) => {
    const filter = { entityType: 'asset' };
    const assetAttributes = await ApiService.bulkDownloadEntityAttributes({ filter });
    dispatch(setAssetAttributes(assetAttributes));
  };
}
